'use client';

import { useNuqsNextAppRouterAdapter } from '../../chunk-WSSTNRLI.js';
import '../../chunk-TUUFGL5M.js';
import '../../chunk-3RCMAOX7.js';
import { createAdapterProvider } from '../../chunk-OMREKXUP.js';

// src/adapters/next/app.ts
var NuqsAdapter = createAdapterProvider(useNuqsNextAppRouterAdapter);

export { NuqsAdapter };
